var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNs(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2566_28381",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 7,
    width: 40,
    height: 40
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 7,
    width: 40,
    height: 40,
    rx: 4,
    fill: "#09111C"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2566_28381)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2.46484,
    y: 30,
    width: 40,
    height: 4,
    transform: "rotate(60 2.46484 30)",
    fill: "#09111C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.46484,
    y: 16,
    width: 40,
    height: 4,
    transform: "rotate(60 3.46484 16)",
    fill: "#09111C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.46484,
    y: 2,
    width: 52.7967,
    height: 4,
    transform: "rotate(60 4.46484 2)",
    fill: "#09111C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.46484,
    y: -11,
    width: 71.9701,
    height: 4,
    transform: "rotate(60 6.46484 -11)",
    fill: "#09111C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.4648,
    y: -12,
    width: 71.9701,
    height: 4,
    transform: "rotate(60 15.4648 -12)",
    fill: "#09111C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.4648,
    y: -9,
    width: 71.9701,
    height: 4,
    transform: "rotate(60 26.4648 -9)",
    fill: "#09111C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35.4648,
    y: -9,
    width: 71.9701,
    height: 4,
    transform: "rotate(60 35.4648 -9)",
    fill: "#09111C"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNs);
export default __webpack_public_path__ + "static/media/N&S.7875318847fe21718bcd921a8d2fdc76.svg";
export { ForwardRef as ReactComponent };